import { render, staticRenderFns } from "./SucursalRespuestaNegativa.vue?vue&type=template&id=5b60aeff"
import script from "./SucursalRespuestaNegativa.vue?vue&type=script&lang=js"
export * from "./SucursalRespuestaNegativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports